<template>
  <div id="content" class="candidate_pool_main">
    <GraphUploader :dialogVisible='dialogGraph' @close="closeModalGraph"  @newValueIsProposed="imageChange($event)" :fileType="fileType" :startup="modalStartup" :graphName="modalName" :search_field="modalSearchField"></GraphUploader>
    <ComparisonGraphUploader :dialogVisible='dialogComparison' @close="closeModalComparisonGraph"  @newValueIsProposed="imageComparisonChange($event)" :fileType="fileType" :a="modalComparisonA" :b="modalComparisonB" :graphName="modalName" :search_field="modalSearchField"></ComparisonGraphUploader>
    <AddCommentModal :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="setNewValueComment($event)" formName="Add a comment" ></AddCommentModal>

    <div class="container">
      <div class="candidate_pool">
        <h1 class="text-center">{{assessment.sft}}</h1>
        <div class="row mt50">


        <h2>Individual innovators assessment</h2>

        <div class="row  mb50 ">
          <div class="col-12 oneStartup"   v-for="(candidate, c) in assessment.candidate_to_assess" :key="c">
            <div class="small_startup ">
              <span class="startup_title">{{candidate.startup.name}}</span>
            </div>
            <div class="row" style="margin-top:20px; border:1px solid #CCC;padding:10px;">
              <div class="col-12">
                Comments :
                <div class="candidate_links candidate_comments" style="">
                  <div  v-if="candidate.comments">
                   <div class="comments_list"  v-if="candidate.comments">
                      <div class="one_comment" v-for="(comment, i) in candidate.comments" :key="i">
                        <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                            <span v-else>{{comment}}</span>
                      </div>

                  </div>
                      </div>
                  <div class="add_comment col-12 text-right">
                      <button type="button" class="add_new_comment" @click='openModal(candidate)' name="button">
                        <img :src="require('@/assets/comments.svg')" alt="">
                        Add a comment</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-xl-4 mt50">
                <div class="item_card">
                  <span class="item_card_title">STRATEGIC FIT</span>
                  <div class="item_card_content" v-if="candidate.strategic_fit">
                    <div class="changeImage" v-if="assessment.isExpertSubmit != true">
                      <button type="button" name="button"  @click="openModalGraph(candidate,'strategic fit')"  >+ CHANGE</button>
                    </div>
                    <img :src="this.apiUrl+'/get_image/'+candidate.strategic_fit.$oid+'?token='+$store.state.innotoken"  class="img-fluid assessment_report" alt="" @click="visibleRef_strategic_fit = true">
                  </div>
                  <div class="" v-else>
                    <button type="button" class="prev_step_btn" @click="openModalGraph(candidate,'strategic fit')" name="button"  v-if="assessment.isExpertSubmit != true">Upload strategic fit</button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl-4 mt50">
                <div class="item_card">
                  <span class="item_card_title">ANALYTICAL SUPPORT</span>
                  <div class="item_card_content" v-if="candidate.analytical_support">
                    <div class="changeImage" v-if="assessment.isExpertSubmit != true" >
                      <button type="button" name="button"  @click="openModalGraph(candidate,'analytical support')"  v-if="assessment.isExpertSubmit != true">+ CHANGE</button>
                    </div>
                    <img :src="this.apiUrl+'/get_image/'+candidate.analytical_support.$oid+'?token='+$store.state.innotoken"  class="img-fluid assessment_report" alt="" @click="visibleRef_strategic_fit = true">
                  </div>
                  <div class="" v-else>
                    <button type="button" class="prev_step_btn" @click="openModalGraph(candidate,'analytical support')" name="button"  v-if="assessment.isExpertSubmit != true">Upload analytical support</button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl-4 mt50">
                <div class="item_card">
                  <span class="item_card_title">READINESS FOR PARTNERSHIP</span>
                  <div class="item_card_content" v-if="candidate.readiness_for_partnership">
                    <div class="changeImage" v-if="assessment.isExpertSubmit != true">
                      <button type="button" name="button"  @click="openModalGraph(candidate,'readiness for partnership')"  v-if="assessment.isExpertSubmit != true">+ CHANGE</button>
                    </div>
                    <img :src="this.apiUrl+'/get_image/'+candidate.readiness_for_partnership.$oid+'?token='+$store.state.innotoken"  class="img-fluid assessment_report" alt="" @click="visibleRef_strategic_fit = true">
                  </div>
                  <div class="" v-else>
                    <button type="button" class="prev_step_btn" @click="openModalGraph(candidate,'readiness for partnership')" name="button"  v-if="assessment.isExpertSubmit != true">Upload readiness for partnership</button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl-4 mt50">
                <div class="item_card">
                  <span class="item_card_title">360° assessment report</span>
                  <div class="item_card_content" v-if="candidate.assessment_report">

                    <button class="changeImage_relative" type="button" name="button" @click="openModalGraphPdf(candidate,'assessment report')"  v-if="assessment.isExpertSubmit != true">+ CHANGE</button>
                    <a :href="this.apiUrl+'/get_image/'+candidate.assessment_report.$oid+'?token='+$store.state.innotoken" target="_blank" class="changeImage_relative_outline" alt="" @click="visibleRef_strategic_fit = true">
                      See the report
                    </a>
                  </div>
                  <div class="" v-else>
                    <button type="button" class="prev_step_btn" @click="openModalGraphPdf(candidate,'assessment report')" name="button"  v-if="assessment.isExpertSubmit != true">Upload assessment report</button>
                  </div>
                </div>
              </div>

              <div class="col-12 col-xl-4 mt50">
                <div class="item_card">
                  <span class="item_card_title">RECOMMENDATION</span>
                  <div class="item_card_content">
                    <div class="barcontainer">
                      <div :class="'bar '+candidate.collab_interest_level">
                      </div>
                      <div class="jauge" >
                          <label :for="'low'+c" class="jauge_label low">
                            <input type="radio" :name="candidate.startup_id+c" :id="'low'+c" value="low" v-model="candidate.collab_interest_level"  @change="filterChanged(candidate)" :disabled="assessment.isExpertSubmit" />
                            <div class="info">
                              <span>Low</span>
                              <small>No Interest</small>
                            </div>
                          </label>
                          <label :for="'medium'+c" class="jauge_label medium">
                            <input type="radio" :name="candidate.startup_id+c" :id="'medium'+c" value="medium" v-model="candidate.collab_interest_level" @change="filterChanged(candidate)" :disabled="assessment.isExpertSubmit" />
                            <div class="info">
                              <span>Medium</span>
                              <small>Consider for later</small>
                            </div>
                          </label>
                          <label :for="'high'+c" class="jauge_label high">
                            <input type="radio" :name="candidate.startup_id+c" :id="'high'+c" value="high" v-model="candidate.collab_interest_level"  @change="filterChanged(candidate)" :disabled="assessment.isExpertSubmit"/>
                            <div class="info">
                              <span>High</span>
                              <small>Progress now</small>
                            </div>

                          </label>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

        </div>
        <div class="row  mb50 ">
                    <h2>Comparison reports</h2>
          <div class="col-12 oneStartup"   v-for="(candidate, c) in assessment.comparisons" :key="c">
            <div class="row">
              <div class="col-12  mt20">
                <!-- <div class="small_startup ">
                  <img :src="this.apiUrl+'/get_image/'+candidate.a.image.$oid+'?token='+$store.state.innotoken" alt="" class="roundImage"  v-if="candidate.a.image">
                  <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="roundImage" alt="" v-else>

                  <span>{{candidate.a.name}}</span>
                </div>
                <div class="and">
                  VS
                </div>
                <div class="small_startup ">
                  <img :src="this.apiUrl+'/get_image/'+candidate.b.image.$oid+'?token='+$store.state.innotoken" alt="" class="roundImage"  v-if="candidate.b.image">
                  <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="roundImage" alt="" v-else>

                  <span>{{candidate.b.name}}</span>
                </div> -->
                <span class="startup_title">{{candidate.a.name}} VS {{candidate.b.name}}</span>
              </div>
              <div class="col-12 ">
                <div class="row">
                  <div class="col-12 col-xl-4 mt20">
                    <div class="item_card">
                      <span class="item_card_title">Strategic fit comparison</span>
                      <div class="item_card_content" v-if="candidate.strategic_fit">
                        <div class="changeImage" v-if="assessment.isExpertSubmit != true">
                          <button type="button" name="button"  @click="openModalComparisonGraph(candidate.a,candidate.b,'strategic fit comparison')"  v-if="assessment.isExpertSubmit != true">+ CHANGE</button>
                        </div>
                        <img :src="this.apiUrl+'/get_image/'+candidate.strategic_fit.$oid+'?token='+$store.state.innotoken"  class="img-fluid assessment_report" alt="" @click="visibleRef_strategic_fit = true">
                      </div>
                      <div class="" v-else>
                        <button type="button" class="prev_step_btn" @click="openModalComparisonGraph(candidate.a,candidate.b,'strategic fit comparison')" name="button" v-if="assessment.isExpertSubmit != true">Upload strategic fit comparison</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-xl-4 mt20">
                    <div class="item_card">
                      <span class="item_card_title">Readiness for partnership comparison</span>
                      <div class="item_card_content" v-if="candidate.readiness_for_partnership">
                        <div class="changeImage" v-if="assessment.isExpertSubmit != true">
                          <button type="button" name="button"  @click="openModalComparisonGraph(candidate.a,candidate.b,'readiness for partnership comparison')"  v-if="assessment.isExpertSubmit != true">+ CHANGE</button>
                        </div>
                        <img :src="this.apiUrl+'/get_image/'+candidate.readiness_for_partnership.$oid+'?token='+$store.state.innotoken"  class="img-fluid assessment_report" alt="" @click="visibleRef_strategic_fit = true">
                      </div>
                      <div class="" v-else>
                        <button type="button" class="prev_step_btn" @click="openModalComparisonGraph(candidate.a,candidate.b,'readiness for partnership comparison')"  v-if="assessment.isExpertSubmit != true" name="button">Upload readiness for partnership comparison</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-xl-4 mt20">
                    <div class="item_card">
                      <span class="item_card_title">Comparison report</span>
                      <div class="item_card_content" v-if="candidate.comparison_report">

                        <button class="changeImage_relative" type="button" name="button"  @click="openModalComparisonGraphPDF(candidate.a,candidate.b,'comparison report')"  v-if="assessment.isExpertSubmit != true">+ CHANGE</button>
                        <a :href="this.apiUrl+'/get_image/'+candidate.comparison_report.$oid+'?token='+$store.state.innotoken" target="_blank" class="changeImage_relative_outline" alt="" @click="visibleRef_strategic_fit = true">
                          See the report
                        </a>
                      </div>
                      <div class="" v-else>
                        <button type="button" class="prev_step_btn" @click="openModalComparisonGraphPDF(candidate.a,candidate.b,'comparison report')" name="button"  v-if="assessment.isExpertSubmit != true">Upload comparison report</button>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
        <div class="col-12" v-if="assessment.lastEdit">
          Last modification date: {{assessment.lastEdit.date}}
        </div>
        <div class="col-12 text-center mt50" >

            <button v-if="assessment.isExpertSubmit != true" type="button" name="button" class="next_step_btn" @click="submit_assessement()">
              SUBMIT ASSESSMENT
              <img :src="require('@/assets/next.svg')" alt="">
            </button>

            <div class="alert alert-info" v-if="assessment.isExpertSubmit">
            You have already provided the business challenge analysis. Once it's validated by the administrator, it will be submitted to the customer.
            </div>
        </div>
      </div>






    </div>


  </div>
</template>
<script>
// import exportFromJSON from "export-from-json";
 import { toast } from 'vue-sonner'
 import api from '@/tools/api';
import GraphUploader from '@/components/modals/assessentGraphUploader.vue'
import ComparisonGraphUploader from '@/components/modals/assessentComparisonGraphUploader.vue'
 import AddCommentModal from '@/components/modals/addComment.vue'

export default {
  components: {
    GraphUploader,
    ComparisonGraphUploader,
    AddCommentModal
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      assessment: {},
      pageInfo: {
        mainTitle : "Assessment space",
        subTitle : "Complete the assessment challenge",
      },
      dialogComparison:false,
modalComparisonA:"",
modalComparisonB:"",
      dialog: false,
      dialogGraph: false,
      modalStartup : "",
      modalName: "",
      modalSearchField :"",
      fileType :".png, .jpg, .jpeg"
    }
  },
  methods:{
    closeModal(){
      this.candidateForComments = "";
      this.dialog = false;
    },
    openModal(candidate){
      this.candidateForComments = candidate;
      this.dialog = true;
    },
    setNewValueComment(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/assessment/candidate/add_comment",
        {
          comment : v,
          candidate : this.candidateForComments,
          sf:this.$route.params.search_field_id,
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        toast.success("Your comment is added");
          this.candidateForComments.comments.push(r.data);
          this.candidateForComments = null;
      }).catch( () => {
          this.candidateForComments = null;
          toast.error("Sorry an error occurs !")
      });

      }

      this.dialog = false;
    },

    filterChanged(candidate){
      console.log(candidate.startup_id);
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/set_assessment_reco",          {
                    search_field: this.$route.params.search_field_id,
                    candidate_id: candidate.startup_id.$oid,
                    candidate_reco: candidate.collab_interest_level
                },
                {
                  headers: {
                      'Content-Type': 'application/json',
                }
              }).then( (r) => {
                console.log(r);
                toast.success("Your recommendation has been saved!")

      }).catch( (e) => {
        console.log(e);
         toast.error("Sorry an error occurs !")
    });
    },
    submit_assessement(){
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/expert_submit_assessment",{
                    search_field: this.$route.params.search_field_id,
                    assessment: this.assessment._id.$oid

                },
                {
                  headers: {
                      'Content-Type': 'application/json',
                }
              }).then( (r) => {
                console.log(r);
                toast.success("Assessment has been submitted")
                  this.assessment.isExpertSubmit = true;
            }).catch( (e) => {
              console.log(e);
               toast.error("Sorry an error occurs !")
          });
    },

    closeModalGraph(){
              this.dialogGraph = false;
      this.modalStartup  = "";
      this.modalName = "";
      this.modalSearchField  ="";

    },
    openModalGraph(candidate, type){
      this.modalStartup  = candidate;
      this.modalName = type;
      this.modalSearchField  = this.$route.params.search_field_id;
      this.dialogGraph = true;
      this.fileType = ".png, .jpg, .jpeg";
    },
    openModalGraphPdf(candidate, type){
      this.modalStartup  = candidate;
      this.modalName = type;
      this.modalSearchField  = this.$route.params.search_field_id;
      this.dialogGraph = true;
      this.fileType = ".pdf";
    },

    closeModalComparisonGraph(){
              this.dialogComparison = false;
              this.modalComparisonA  = {};
              this.modalComparisonB  = {};
      this.modalName = "";
      this.modalSearchField  ="";

    },
    openModalComparisonGraph(a,b, type){
      this.modalComparisonA  = a;
      this.modalComparisonB  = b;
      this.modalName = type;
      this.modalSearchField  = this.$route.params.search_field_id;
      this.dialogComparison = true;
      this.fileType = ".png, .jpg, .jpeg";
    },
    openModalComparisonGraphPDF(a,b, type){
      this.modalComparisonA  = a;
      this.modalComparisonB  = b;
      this.modalName = type;
      this.modalSearchField  = this.$route.params.search_field_id;
      this.dialogComparison = true;
      this.fileType = ".pdf";
    },
    imageComparisonChange(val){
      console.log(val);
      var newObjArr = null;
      if(val.type == "strategic fit comparison"){
       newObjArr = this.assessment.comparisons.map(obj => {
          if (obj.a == val.a && obj.b == val.b) {
            obj.strategic_fit = val.file;
              return obj
          }
          return obj
        });

      }
      if(val.type == "readiness for partnership comparison"){
       newObjArr = this.assessment.comparisons.map(obj => {
          if (obj.a == val.a && obj.b == val.b) {
            obj.readiness_for_partnership = val.file;
              return obj
          }
          return obj
        });

      }
      if(val.type == "comparison report"){
       newObjArr = this.assessment.comparisons.map(obj => {
          if (obj.a == val.a && obj.b == val.b) {
            obj.comparison_report = val.file;
              return obj
          }
          return obj
        });

      }
      this.assessment.comparisons = newObjArr;
      this.dialogComparison = false;
this.modalComparisonA  = {};
this.modalComparisonB  = {};
this.modalName = "";
this.modalSearchField  ="";
    },
    imageChange(val){
      console.log(val);
        var newObjArr = null;
      if(val.type == "analytical support"){
       newObjArr = this.assessment.candidate_to_assess.map(obj => {
          if (obj.startup_id == val.candidate) {
            obj.analytical_support = val.file;
              return obj
          }
          return obj
        });
        this.assessment.candidate_to_assess = newObjArr;
      }

      else if(val.type == "strategic fit"){
         newObjArr = this.assessment.candidate_to_assess.map(obj => {
          if (obj.startup_id == val.candidate) {
            obj.strategic_fit = val.file;
              return obj
          }
          return obj
        });
        this.assessment.candidate_to_assess = newObjArr;
      }
      else if(val.type == "readiness for partnership"){
         newObjArr = this.assessment.candidate_to_assess.map(obj => {
          if (obj.startup_id == val.candidate) {
            obj.readiness_for_partnership = val.file;
              return obj
          }
          return obj
        });
        this.assessment.candidate_to_assess = newObjArr;
      }
      else if(val.type == "assessment report"){
         newObjArr = this.assessment.candidate_to_assess.map(obj => {
          if (obj.startup_id == val.candidate) {
            obj.assessment_report = val.file;
              return obj
          }
          return obj
        });
        this.assessment.candidate_to_assess = newObjArr;
      }
      this.dialog = false;
      this.modalStartup  = "";
      this.modalName = "";
      this.modalSearchField  ="";
    }
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)


     api.get(process.env.VUE_APP_API_URL+"/restrict/search_field/get_assessment/"+this.$route.params.search_field_id).then( (r) => {
       console.log(r.data);
       this.assessment = r.data;

     }).catch( (e) => {
       console.log(e);
        toast.error("Sorry an error occurs !")
   });
 },
  computed:{
  }
}
</script>
<style scoped>
.candidate_pool_main{
  padding-top:50px;
  padding-bottom:50px;
}
.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}


.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
}
.all_candidates_download_zone .description{
  display:block;
  margin-top:10px;
  margin-bottom: 20px;
  width:100%;
}

  .next_step_btn{
    background: #3783C5 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 14px 37px;
    color:#FFF;
    margin:5px;
  }
  .next_step_btn img.left{
    margin-right:10px;
  }
img.goFullWhite{
  filter: brightness(0) invert(1);
}
.candidate_pool{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
margin-bottom:50px;
margin-top: 50px;
}

.pool_title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
}
.pool_subtitle{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
display:block;
}
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 1px solid #DDDDDD;
border-radius: 10px;
z-index: 5;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.candidate_card .candidate_info_content{
  padding:20px;
  border-bottom: 1px solid #DDDDDD;
}

.candidate_card .candidate_links{
  padding:20px;
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}
.candidate_name{
 font-size:18px;
 line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}
.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:1;
  align-items: flex-end;

}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
}
.mt50{
  margin-top: 50px;
}

.selection{
  margin-top:50px;
  border-top:1px solid #DDD;
  padding-top: 50px;

}
.selection .selectedOne{
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  width: calc(33% - 20px);
}
.selection .selectedOne img{
    width: 65px;
    height:65px;
    border-radius: 6px;
    object-fit: cover;
    margin-right: 10px;
}

.selection .candidateSelection{
  display:flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top:50px;
}

@media screen and (max-width: 1200px){
  .selection .selectedOne{
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    width: calc(50% - 20px);
  }
}
@media screen and (max-width: 990px){
  .selection .selectedOne{
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    width: calc(100%);
  }
  .selection .candidateSelection{
    flex-direction: column;
  }
}

.onePool:not(:first-of-type){
  margin-top:50px;
}

.askNewPool button{
  font-size:12px;
  line-height: 15px;
}
.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}
.prev_step_btn img{
  margin-right:10px;
}
a{
  color:inherit;
}

.mt20{
  margin-top:20px;
}


.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}

.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}

a{
  text-decoration: none;
}


.candidate_image_small{
  width:100px;
  height:100px;
  object-fit: cover;
  border-radius:50%;
}

.addNewStartup {
  border: 1px solid #CCC;
  padding-bottom: 25px;
  margin-bottom: 25px;
  padding-left: 0;
  padding-right: 0;
}
.addNewStartup img{
  filter: brightness(0) invert(1);
}
.addNewStartToogler{
  width: 100%;
border: none;
background: #CCC;
border-radius: 0;
margin: 0;
color: #FFF;
font-weight: 700;

padding: 14px 37px;
text-decoration: none;
}

.addNewStartup_content{
  padding: 20px;
}

.submitPool{
  width: auto;
margin: auto;
}

.onePool table tr{
  border-bottom : 1px solid #CCC;
}
.btnContainer{
  display:flex;
  flex-wrap: wrap;
  gap:20px;
  color: #FFF;
  width:100%;
  justify-content: flex-end;
  margin-top:20px;
  margin-bottom: 20px;
}


td.startupImg{
  width:10%;
}
td.startupName{
  width:70%;
}
td.startupAction{
  width:20%;
}

@media screen and (max-width:990px){
  td.startupAction{
    width:100%;
    display:flex;
    margin-bottom: 20px;
  }
  td.startupImg{
    width:20%;
  }
  td.startupName{
    width:80%;
  }
  .poolTab{
    display: flex;
    margin: 0;
    gap: 20px;
    flex-wrap: wrap;
  }
  .poolTab tr{
    width:100%;
  }
  td.startupAction .btnContainer{
    margin:auto;
    justify-content: center;
  }
}




.small_startup{
  display:flex;
  gap:10px;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  text-transform:uppercase;
}

.small_startup .roundImage{
border: 2px solid #B38D2F;
padding: 5px;
border-radius: 50%;
border-right: none;
border-top: none;
margin-right:10px;
height:100px;
width:100px;
object-fit: cover;
}



.changeImage{
  position:absolute;
  top:10px;
  left:10px;
  font-size:12px;
  color:#FFF;
  background: #3783C5;
  border-radius:200px;
  padding:5px 10px;

}
.changeImage_relative{
  font-size:12px;
  color:#FFF;
  background: #3783C5;
    border: 1px solid #3783C5;
  border-radius:200px;
  padding:5px 10px;
  display:inline-block;
  text-transform: uppercase;
  margin:10px;

}

.changeImage_relative_outline{
  font-size:12px;
  color:#3783C5;
  border: 1px solid #3783C5;
  padding:5px 10px;
  display:block;
  text-transform: uppercase;
  margin:10px;
  margin:auto;
  text-align: center;

}
.item_card_content{
  position: relative;
  display: block;
  width: 100%;
}

.mt20{
  margin-top:20px;
}

.item_card{
  border: 1px solid #DDD;
  border-radius: 10px;
padding: 20px;
position:relative;
padding-top: 40px;
margin-top: 20px;
align-content: center;
align-items: center;
align-self: center;
justify-content: center;
display: flex;
height:100%;
}
.item_card .item_card_title{
  position:absolute;
  top: 0px;
  transform: translateY(-50%);
  left: 20px;
  background: #FFF;
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 24px;
  padding-left: 20px;
  padding-right: 20px;
}

.mb50{
  margin-bottom:50px;
}
.oneStartup .startup_title{
  font-weight: bold;
}
.oneStartup{
  padding-top:50px;
  padding-bottom: 50px;
  border-bottom: 1px solid #CCC;
}




.barcontainer{
  background-color: #DDDDDD;
  position: relative;
  margin-left: 50px;
  width: 30px;
  height: 200px;
}
.bar{
  background-color: #3783C5;
  position: absolute;
  bottom: 0;
  width: 100%;

  box-sizing: border-box;
  -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
  transform-origin: bottom;
}
.bar.low{
  height: 10%;
}
.bar.medium{
  height: 50%;
}

.bar.high{
  height: 90%;

}

@keyframes grow{
  from{
    transform: scaleY(0);
  }
}

.jauge_label.low{
  position: absolute;
  bottom :10%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label.medium{
  position: absolute;
  bottom :50%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}


.jauge_label.high{
  position: absolute;
  top :10%;
  transform: translateY(-50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label::before{
  content :" ";
  background: #707070;
  width:10px;
  height:1px;
  left: -10px;
  position:absolute;
  top: 50%;
}
.jauge_label input{
  width:22px;
  height:22px;
}

.jauge_label span{
  display:block;
  color: #3783C5;
  font-size: 14px;
  line-height: 22px;
  width:100%;
  font-weight: 500;
  text-transform:uppercase;
}
.jauge_label small{
  color: #575757;
  font-weight: 300;
  font-size:14px;
  line-height: 22px;
}

.and{
  width:100%;
  font-weight: bold;
  font-size:30px;
}

.jauge_label{
  text-align:left !important;
}
</style>
